import { Loader, Stack } from "@mantine/core";
import { useParams } from "@tanstack/react-router";

import { useGetMe } from "../../api/generated/endpoints/identity/identity";
import { ErrorAlert } from "../../platform/ErrorAlert";
import { AccountFrame } from "../../platform/shell/AccountFrame";
import { ProfileSection } from "./ProfileSection";

/**
 * The Account page's Profile tab: all of live's Account page (`/app/account`, audit frontend 3.3),
 * the user's own details. Each later tab, such as achievements or themes, is a route of its own in
 * the same frame (spec web/account-tabs).
 */
export function ProfileScreen() {
  const { teamId } = useParams({ from: "/signed-in/teams/$teamId/account" });
  return (
    <AccountFrame teamId={teamId}>
      <Profile />
    </AccountFrame>
  );
}

/** The Profile tab's body, wherever its frame is (Classic's Account page, or Pro's Settings). */
export function Profile() {
  const me = useGetMe();
  return (
    <Stack gap={24}>
      {me.isError ? <ErrorAlert error={me.error} /> : null}
      {me.data === undefined ? (
        me.isError ? null : <Loader size="sm" aria-label="Loading your account" />
      ) : (
        <ProfileSection key={me.data.id} me={me.data} />
      )}
    </Stack>
  );
}
